import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/roles/create/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ROLES, permission: Permission.CREATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
